import React, { useEffect, useRef, useState } from 'react';
import * as d3 from 'd3';
import data from './goldmedalistsinfo.json';
import './dataviz.scss';
import Tooltip from './Tooltip';
import ImageScroll from './ImagesScroll';
import gsap from 'gsap';
// import ScrollTrigger from 'gsap/ScrollTrigger';

function GenderLongevityV2() {
    const svgRef = useRef();
    const containerRef = useRef();

    const [tooltipContent, setTooltipContent] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
    const [hovered, setHovered] = useState(null);

    const [isToggled, setIsToggled] = useState(false);

    const handleToggle = () => {
        setIsToggled(!isToggled);
    };
    

    const sex = ['F', 'M'];

    const colorLine = d3.scaleOrdinal()
        .domain(['M', 'F']) 
        .range(['#1EB246', '#6434FF']); 

    const path = process.env.PUBLIC_URL;

    useEffect(() => {
        drawChart();
    
        let prevWidth = window.innerWidth;
        const handleResize = debounce(() => {
          const currentWidth = window.innerWidth;
          const widthDifference = Math.abs(currentWidth - prevWidth);
          
          if (widthDifference > 50) {
              drawChart();
              prevWidth = currentWidth;
          }
      }, 500);
    
      window.addEventListener('resize', handleResize);
    
        return () => {
            window.removeEventListener('resize', handleResize);
            // ScrollTrigger.getAll().forEach(trigger => trigger.kill());
        };
    }, [isToggled]); 

    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    const drawChart = () => {
        // gsap.registerPlugin(ScrollTrigger);

        // Check if we're on a mobile device
        const isMobile = window.innerWidth <= 768;

        // const scrollTriggerInitialized = ScrollTrigger.getById('gender-long-id');

        // // If we're on mobile and the chart has already been drawn, exit early
        // if (isMobile && svgRef.current.querySelector('.longevity-circle')  ) {
        //     return;
        // }

        // const margin = { top: 20, right: 30, bottom: 40, left: 60 };
        // const width = 960 - margin.left - margin.right;
        // const height = 700 - margin.top - margin.bottom;

        // const svg = d3.select(svgRef.current)
        // .attr('width', width + margin.left + margin.right)
        // .attr('height', height + margin.top + margin.bottom)
        // .append('g')
        // .attr('transform', `translate(${margin.left},${margin.top})`);

        const container = d3.select(containerRef.current);
        const svg = d3.select(svgRef.current);
        const containerWidth = container.node().clientWidth;
        const containerHeight = container.node().clientHeight;

        // Retrieve the computed style of the SVG
        const computedStyle = window.getComputedStyle(svgRef.current);
    
        // Parse the CSS width as a float (removing 'px')
        const svgCssWidth = parseFloat(computedStyle.width);

        const margin = { top: 2, right: 0, bottom: 40, left: 75 };
        // const width = containerWidth - margin.left - margin.right;
        // const height = containerHeight - margin.top - margin.bottom;
        const width = isMobile ? svgCssWidth * 0.78 :containerWidth - margin.left - margin.right;
        const height = isMobile ? 650 : containerHeight - margin.top - margin.bottom; 

        svg
        .attr('viewBox', `0 0 ${containerWidth} ${containerHeight}`)
        .attr('preserveAspectRatio', 'xMinYMin meet')
        .attr('width', '100%')
        .attr('height', '100%');


        const svgGroup = svg
        .selectAll('g')
        .data([null])
        .join('g')
        .attr('transform', `translate(${margin.left},${margin.top})`);

        // filters
        // const sportsData = data.filter(d =>
        //     ['举重', '乒乓球', '体操', '击剑', '射击', '田径', '羽毛球', '花样滑水', '跆拳道', '跳水'].includes(d.sportcn)
        //     );

        const sportsData = data.filter(d =>
            ['Weightlifting', 'Table Tennis', 'Gymnastics', 'Fencing', 'Shooting', 'Athletics', 'Badminton', 'Taekwondo', 'Diving'].includes(d.sport)
            );

        const ageData = data.filter(d => d.ageRetired !== "现役" && ['Weightlifting', 'Table Tennis', 'Gymnastics', 'Fencing', 'Shooting', 'Athletics', 'Badminton', 'Taekwondo', 'Diving'].includes(d.sport));

        const medianAgeData = d3.group(ageData, d => `${d.sport}-${d.sex}`);

        const medianAges = Array.from(medianAgeData, ([key, values]) => {
            const ages = values.map(d => +d.ageRetired).sort(d3.ascending);
            const median = d3.median(ages);
            const [sport, sex] = key.split('-');
            return { sport, sex, median };
        });

        const genderGroup = d3.group(ageData, d => d.sex);

        // Calculate median ages for each gender
        const genderMedians = Array.from(genderGroup, ([sex, values]) => {
            const ages = values.map(d => +d.ageRetired).sort(d3.ascending);
            const median = d3.median(ages);
            return { sex, median }; 
        });

        // const sortedMedianAges = medianAges.sort((a, b) => {
        //     if (a.sportcn === b.sportcn) {
        //         return a.sexcn.localeCompare(b.sexcn);
        //     }
        //     return a.sportcn.localeCompare(b.sportcn);
        // })


        // const sortedMedianAges = medianAges.sort((a, b) => {
        //     if (a.sportcn === b.sportcn) {
        //         return a.sexcn === '女' ? -1 : 1; // Ensure '女' appears before '男'
        //     }
        //     return d3.ascending(a.sportcn, b.sportcn);
        // });

        const sortedMedianAges = medianAges.sort((a, b) => {
            if (a.sport !== b.sport) {
                return d3.ascending(a.sport, b.sport);
            }
            return a.sex === 'F' ? -1 : 1;
        });

        
        // Set the scales
        const x = d3.scaleLinear()
        // .domain(ageData.map(d => d.ageRetired))
        // .domain([d3.min(ageData, d => d.ageRetired), d3.max(ageData, d => d.ageRetired)])
        .domain([15, 50])
        .range([0, width]);

        const y = d3.scaleBand()
        .domain(sportsData.map(d => d.sport))
        .range([0, height])
        .padding(0);

        const color = d3.scaleOrdinal()
        .domain(['M', 'F']) 
        .range(['#71DF96', '#BB96FF']); 

        const colorLine = d3.scaleOrdinal()
        .domain(['M', 'F']) 
        .range(['#1EB246', '#6434FF']); 
        
        const genderGroupData = Array.from(d3.group(ageData, d => d.sport), ([key, value]) => ({ key, values: value }));

        svgGroup.selectAll('line').remove(); 
        // grid and axes
        svgGroup.append('g')
            .selectAll('line')
            .data(sportsData)
            .enter().append('line')
            .attr('class', 'grid-lines')
            .attr('x1', 0)
            .attr('y1', d => y(d.sport) + y.bandwidth() / 2)
            .attr('x2', width)
            .attr('y2', d => y(d.sport) + y.bandwidth() / 2)
            .attr('transform', `translate(0, ${y.step() / 2})`);
        
        //toppity
        svgGroup.append('line')
            .attr('class','grid-lines')
            .attr('x1', 0)
            .attr('y1', 0)
            .attr('x2', width)
            .attr('y2', 0);

        const tickFormat = (d) => `Age ${d}`;

        svgGroup.append('g')
            .attr('transform', `translate(0,${height})`)
            .call(d3.axisBottom(x).tickFormat(tickFormat))
            .attr('class', 'x-axis')
            .call(g => g.selectAll('.tick line')
                .attr('class', 'grid-lines')
                .attr('y2', -height));
        

            
        // svgGroup.append('g')
        // .attr('class', 'x-axis')
        // .attr('transform', `translate(0,${height})`)
        // .call(d3.axisBottom(x)
        // );

        // y-axsis
        svgGroup.append('g')
        .attr('class', 'y-axis longevity')
        .call(d3.axisLeft(y))
        .select('.domain').remove()
        .transition().duration(500).delay(100)
        ;

        const jitter = 50;
        const jittery = 8;

        const spacing = 6;
        const sportAgeData = d3.group(ageData, d => d.sport, d => d.ageRetired);

       
        const flattenedData = ageData.map(d => {
            // Find all points at the same x position
            const samePositionData = Array.from(sportAgeData.get(d.sport)?.get(d.ageRetired) || []);

            // Calculate the x position with spacing
            const index = samePositionData.indexOf(d);
            const numPoints = samePositionData.length;

            return {
                ...d,
                xPosition: x(d.ageRetired) + (index - (numPoints - 1) / 2) * spacing,
            };
        });

        svgGroup.selectAll('circle').remove(); 

        const circles = svgGroup.selectAll('circle')
            .data(ageData, d => d.id);

        circles.enter().append('circle')
            .data(flattenedData)
            // .attr('cx', d => x(d.ageRetired))
            .attr('cx', d => d.xPosition)
            .attr('cy', d => {
                if (d.sex === 'M') {
                    return y(d.sport) + y.bandwidth() / 2 + 10 + (Math.random() - 0.5) * jittery;
                }
                else if (d.sex === 'F') {
                    return y(d.sport) + y.bandwidth() / 2 - 10 + (Math.random() - 0.5) * jittery;
                }
            })
            .attr('class', 'longevity-circle')
            .attr('r', 6)
            .style('fill', d => color(d.sex))
            .style('stroke', d => color(d.sex))
            .style('stroke-width', '1px')
            .attr('fill-opacity', 0.6)
            .on('mouseover', (event, d) => {
                setTooltipContent(
                    `<div class="tooltip__content">
                    <span class="tooltip__title">
                        <b>${d.name}</b> <br/>
                        <span style="color:${color(d.sex)}"><b>${d.sex == 'F' ? `Women's` : `Men's`} ${d.sport}</b></span></br>
                        </span>
                    <span class="tooltip__details">
                    First gold medal received: <b>${d.firstGoldYear}</b></br>
                    Career length after first gold: <b>${d.retirementYear - d.firstGoldYear} years</b></br>
                    Retirement: <b>Age ${d.ageRetired}</b></br>
                    </span>
                    </div>`);
                setTooltipPosition({ x: event.pageX + 10, y: event.pageY - 28 });
                setHovered(event.target);
            })
            .on('mouseout', () => {
                setTooltipContent(null);
                setHovered(null);
            })
            // .merge(circles)
            .transition().duration(500).delay(100);
            circles.exit().remove();

        svgGroup.selectAll('.medianLine').remove(); 

        svgGroup.selectAll('.medianLine')
            .data(sortedMedianAges)
            .enter().append('rect')
            .attr('class', 'medianLine')
            // .attr('x', d => x(d.median) - 1)
            .attr('x', d => {
                if (d.sex === 'M') {
                    return (x(d.median) - 1.5) - 1.5
                } else if (d.sex === 'F') {
                    return (x(d.median) - 1.5) + 1.5
                }
            })
            .attr('y', d => {

                if (d.sex === 'M') {
                    return y(d.sport) + y.bandwidth() / 2 - y.bandwidth() / 2 + 28;
                } else if (d.sex === 'F') {
                    return y(d.sport) + y.bandwidth() / 2 - y.bandwidth() / 2 + 5;
                }
            })
            .attr('width', 3)
            .attr('height', d => y.bandwidth() - 30)
            // .attr('height', 20)
            .attr('fill', d => colorLine(d.sex))
            .on('mouseover', (event, d) => {
                setTooltipContent(`
                    <span class="tooltip__content">
                    <span style="color:${color(d.sex)}"><b>${d.sex == 'F' ? `Women's` : `Men's`} ${d.sport}</b></span></br>
                    </span>
                    <span class="tooltip__details">Retirement median: <b>Age ${d.median}</b></span>`);
                setTooltipPosition({ x: event.pageX + 10, y: event.pageY - 28 });
                setHovered(event.target);
            })
            .on('mouseout', () => {
                setTooltipContent(null)
                setHovered(null);
            })
            .transition().duration(500).delay(100);

        //gender medians
        svgGroup.selectAll('.genderMed')
            .data(genderMedians)
            .enter().append('line')
            .attr('class', 'genderMed')
            .attr('x1', d => x(d.median))
            .attr('x2', d => x(d.median))
            .attr('y1', height/9 * 6 - 10)
            .attr('y2', height/9 * 8 + 10)
            .attr('stroke', d => colorLine(d.sex))
            .attr('stroke-width', 3)
            .attr('opacity', 0)
            .on('mouseover', (event, d) => {
                setTooltipContent(`
                    <span class="tooltip__details">
                    <span style="color:${d.sex === 'M' ? '#1EB246' : '#6434FF'}">
                    ${d.sex == 'M' ? `Men's` : `Women's`} </span>overall retirement median: <span style="color:${d.sex === 'M' ? '#1EB246' : '#6434FF'}; font-weight:bold">Age ${d.median}</span></span>`);
                setTooltipPosition({ x: event.pageX + 10, y: event.pageY - 28 });
            })
            .on('mouseout', () => {
                setTooltipContent(null)
                setHovered(null);
            });


        svgGroup.selectAll('.genderMedText').remove(); 
        svgGroup.append('text')
            .attr('class', 'genderMedText')
            .attr('x', width / 2) 
            .attr('y', height / 1.7) 
            .attr('text-anchor', 'middle') 
            .attr('dominant-baseline', 'middle') 
            .attr('opacity', 0)
            .text('Retirement age by gender')
            ;


if (isToggled) {
    d3.selectAll('.longevity-circle').each(function(d) {
        const circle = d3.select(this);
        const sex = circle.datum().sex;
        const newCy = sex === 'F' ? (height/9 * 6.6 + (Math.random() - 0.5) * jitter) :  (height/9 * 8 - 20  + (Math.random() - 0.5) * jitter);

        gsap.to(circle.node(), {
            attr: {
                cy: newCy
            }
        });
        gsap.to('.longevity .tick', {
            opacity: 0,
        });
        gsap.to('.medianLine', {
            opacity: 0
        });
        gsap.to('.genderMed', {
            opacity: 0.8,
        });
        gsap.to('.genderMedText', {
            duration:1,
            opacity:1
        })
    });
} else {
    d3.selectAll('.longevity-circle').each(function(d) {
        const circle = d3.select(this);
        const sex = circle.datum().sex;
        const sport = circle.datum().sport;

        // Determine new cy position
        const newCy = sex === 'M' 
            ? y(sport) + y.bandwidth() / 2 + 10 + (Math.random() - 0.3) * jittery
            : y(sport) + y.bandwidth() / 2 - 10 + (Math.random() - 0.5) * jittery;

        gsap.to(circle.node(), {
            attr: {
                cy: newCy
            }
        });
        gsap.to('.longevity .tick', {
            opacity: 1,
        });
        gsap.to('.medianLine', {
            opacity: 1,
        });

        gsap.to('.genderMed', {
            opacity: 0,
        });
        gsap.to('.genderMedText', {
            duration:1,
            opacity:0
        })
    });
}


            
        return () => {
            // svgGroup.selectAll('circle').remove();
            // svgGroup.selectAll('.medianLine').remove();
            // svgGroup.selectAll('*').remove();
        }
    }

    return (
        <>

        <div className='content content__heading'>
        <h2>III. Male Olympic Gymnastics champions retire later, with the largest age difference at retirement between male and female gymnasts
        </h2>
            <div className='content__text'>
                <div className='legend'>
                {sex.map((i) => (
            <div key={i} className='legend__item'>
              <div className='legend__color' style={{ borderRight: `3px solid ${colorLine(i)}`, height:'22px' }}></div>
              <div className='legend__label'>{i == 'F' ? `Women's` : `Men's`} retirement median age</div>
              </div>
          ))}
                </div>
            </div>
        </div>

        <div ref={containerRef} className='chart-container'>
        <div className='sticky-div-wrapper'style={{ top:'15px'}}>
            <button onClick={handleToggle} className="toggle-button">
                {isToggled ? 'Sort by sport' : 'Sort by gender'}
            </button>
        </div>
            <svg ref={svgRef} id='gender-longevity'></svg>
            {/* <div className='y-axis' style={{ textAlign:'center' }}><b>年龄</b></div> */}
            <Tooltip content={tooltipContent} position={tooltipPosition} hovered={hovered} />
        </div>
        
        

        <div className='content'>
        <div className='scroll__caption chart-caption'>
        Note: Hover over each circle on the chart to view detailed information about each retired champion.</div>

            <div className='content__text' style={{ paddingBottom:'5%' }}>
                <p>Most Olympic champions continue their sports careers for a period of time after winning their first gold medal. Among different sports, gymnastics champions retire the earliest, while shooting champions have the longest careers.</p>
            </div>

            <div className="scroll-image">
                <div className="sticky-wrapper">
                    <div className='first-image vertical-img'>
                        <img 
                        src={path + '/images/AP24143723469306copy.jpg'} 
                        alt={'1984年7月29日，洛杉矶夏季奥运会上。50米自由手枪射击比赛冠军许海峰站在领奖台上。这是中华人民共和国中国代表团自1952年参加奥运会以来，首次得冠。(AP / Eric Risberg)'} 
                        />
                        <div className="scroll__caption">{"July 29, 1984, at the Los Angeles Summer Olympics, Xu Haifeng, the champion of the 50-meter free pistol shooting event, stands on the podium. This is the first gold medal won by the People's Republic of China delegation since their first participation in the Olympics in 1952. (AP / Eric Risberg)"}</div>
                    </div>
                </div>
                <div className='second-image' >
                    <img 
                    src={path + '/images/202104anhuixuhaifeng.jpg'} 
                    alt={"April 2021, Xu Haifeng (second from left) gives a report in Anhui Province. (Courtesy of the Publicity Department of the Ma'anshan Municipal Committee, Anhui Province)"}
                    />
                    <div className="scroll__caption">{"April 2021, Xu Haifeng (second from left) gives a report in Anhui Province. (Courtesy of the Publicity Department of the Anhui Ma'anshan Municipal Committee)"}</div>
                </div>
            </div>

            

            <div className='content__text'>
                <p>Since the founding of the People's Republic of China, the country has participated in the Olympics since 1952. However, due to <a href='https://www.cfr.org/timeline/olympics-boycott-protest-politics-history' target='_blank'>dissatisfaction with Taiwan</a> competing under the name "China" and other political factors, China boycotted the Olympics for 28 years. China resumed participation in the Olympics in 1980. As of the conclusion of the 2024 Paris Olympics, China has produced over 301 Olympic champions, with female athletes making up approximately 67% of this group. This is directly related to the large number of female athletes in China's Olympic teams. Some media believe that since professional men's sports are well-developed in the West, China, as a latecomer striving to quickly become a global sports powerhouse, must focus on developing women's soccer, softball, and other niche sports to maximize their chances of <a href='https://m.thepaper.cn/baijiahao_13707479' target='_blank'>winning gold medals</a>.</p>
                <p>However, when comparing absolute retirement ages, WHYNOT found that male Olympic champions retire later than their female counterparts. The median retirement age for men is 29 years old, while for women, it is 27. Among sports with both male and female athletes, gymnastics shows the largest gender gap in retirement age, whereas sports like shooting and taekwondo have nearly identical retirement ages for men and women.</p>

            </div>

            <ImageScroll
            src1='/images/AP080817023338.jpg'
            caption1="August 17, 2008, Chinese athlete Guo Jingjing at the awarding ceremony for the women's 3-meter springboard diving final at the Beijing Olympics. (AP / Charles Dharapak)"
            src2='/images/AP21354017704241.jpg'
            caption2='On December 20, 2021, pro-Beijing Hong Kong Legislative Council candidate Kenneth Fok (fourth from the right) celebrated victory in the Legislative Council election with his wife, Guo Jingjing, and other team members. (AP / Vincent Yu)'
            />

        </div>
       
        </>
    );
    };

export default GenderLongevityV2;

